import { Injectable } from '@angular/core';
import { Settings } from './models/settings';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'detamoov',      // detamoov, m3detamoov
        true,        // true = sticky, false = not sticky
        false,       // true = rtl, false = ltr
        1,           //  1, 2  or 3
        false,       //  true = search on button click
        //NOTE:  don't change additional options values, they used for theme performance
        false,
        false,        
        false,      
        false,
        1,
        false,
        0,
        false,
        0
    )
    public homeSettings = new Settings(
        'detamoov',      // detamoov, m3detamoov
        true,        // true = sticky, false = not sticky
        false,       // true = rtl, false = ltr
        1,           //  1, 2  or 3
        true,       //  true = search on button click
        //NOTE:  don't change additional options values, they used for theme performance
        false,
        false,        
        false,
        false,
        1,
        false,
        0,
        false,
        0
    )

    get passwordRegex(){
        return '^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[$@$!%*?&()#^\\[\\]\\-|\\\\/])[a-zA-Z0-9$@$!%*?&()#^\\[\\]\\-|\\\\/]{8,}$';
    }

    get sftpUsernameRegex(){
        return /^(\S*)$/;
    }

    get passwordAllowedSpecialCharacters(){
        return '$@$!%*?&()#^[]-|/\\';
    }

    get fieldNameRegex(){
        return /^([^\"\']+)$/;
    }

    get numberListRegex(){
        return /^[1-9]([0-9]*)(,[1-9][0-9]*)*$/;
    }

    get payrollIdsRegex(){
        return /^[1-9]([0-9]*)(,[1-9][0-9]*)*$/;
    }

    get batchIdsRegex(){
        return /^[1-9,A-Z]{1,2}([0-9]*)(,[1-9,A-Z][0-9]*)*$/;
    }

    get xmlNodeNameRegex(){
        return /^(?!xml|Xml|xMl|xmL|XMl|xML|XmL|XML)[A-Za-z_][A-Za-z0-9-_.]*$/;
    }

    public rolesClaimCatalog!: any[];

    constructor(){
        //careful with the following: it will load the last settings from localStorage which overrides above default settings
        //so if the app was started once with specific settings, it will restart with the same settings unless the browser cache was cleared.
        //this is currently a bit confusing when we use themes. We cannot switch themes as of now, but i still wanted to keep the theme switching in place to allow for customization later.
        let ls_homeSettings = localStorage.getItem('homeSettings');
        let ls_settings = localStorage.getItem('settings');
        //currently make sure detamoov theme is used
        if(ls_homeSettings) {
            this.homeSettings.flatObject=JSON.parse(ls_homeSettings);
            this.homeSettings.theme="detamoov";
        }
        if(ls_settings) {
            this.settings.flatObject=JSON.parse(ls_settings);
            this.settings.theme="detamoov";
        }

        this.homeSettings.ChangedSubject.subscribe(()=>{
            localStorage.setItem('homeSettings',JSON.stringify(this.homeSettings.flatObject));
        });
        this.settings.ChangedSubject.subscribe(()=>{
            localStorage.setItem('settings',JSON.stringify(this.settings.flatObject));
        });
    }

}